import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import CreateAttachmentSharingLinkRequest from 'owa-service/lib/contract/CreateAttachmentSharingLinkRequest';
import CreateAttachmentSharingLinkResponse from 'owa-service/lib/contract/CreateAttachmentSharingLinkResponse';
import createAttachmentSharingLinkRequest from 'owa-service/lib/factory/createAttachmentSharingLinkRequest';
import createAttachmentSharingLinkOperation from 'owa-service/lib/operation/createAttachmentSharingLinkOperation';

export async function createSharingLink(
    resourceLocation: string,
    permissionLevel: AttachmentPermissionLevel,
    dataProvider?: AttachmentDataProviderType
): Promise<CreateAttachmentSharingLinkResponse> {
    return await createAttachmentSharingLinkOperation(
        createRequest(resourceLocation, permissionLevel, dataProvider)
    );
}

function createRequest(
    resourceLocation: string,
    permissionLevel: AttachmentPermissionLevel,
    dataProvider?: AttachmentDataProviderType
): CreateAttachmentSharingLinkRequest {
    return createAttachmentSharingLinkRequest({
        PermissionLevel: permissionLevel,
        ResourceLocation: resourceLocation,
        DataProviderType: dataProvider || AttachmentDataProviderType.OneDrivePro,
    });
}
